import { render, staticRenderFns } from "./ArticleItemVertical.vue?vue&type=template&id=3a74feae&"
import script from "./ArticleItemVertical.vue?vue&type=script&lang=js&"
export * from "./ArticleItemVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\KoRus.Kommunetorget\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a74feae')) {
      api.createRecord('3a74feae', component.options)
    } else {
      api.reload('3a74feae', component.options)
    }
    module.hot.accept("./ArticleItemVertical.vue?vue&type=template&id=3a74feae&", function () {
      api.rerender('3a74feae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Assets/Scripts/components/blocks/ArticleListBlock/ArticleItemVertical.vue"
export default component.exports